// extracted by mini-css-extract-plugin
export default {"spinner":"LazyRoutesBoundary_spinner_bcd31"};